var ICON_SIZES = {
  regular: '1.5rem',
  small: '1rem',
  tiny: '0.75rem'
};

export { ICON_SIZES };
//# sourceMappingURL=sizes.js.map
